import script from "./RcDropdownSubmenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./RcDropdownSubmenu.vue?vue&type=script&setup=true&lang=ts"

import "./RcDropdownSubmenu.vue?vue&type=style&index=0&id=8ce48fe4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ce48fe4"]])

export default __exports__